<div class="modal-content">

  <div class="modal-header">
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">×</span>
    </button>
    <h4 class="modal-title w-100" id="myModalLabel">{{ heading }}</h4>
  </div>
  <div class="modal-body" [innerHTML]="content">
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" aria-label="Close" data-testid="modal-close" (click)="modalRef.hide()" mdbWavesEffect>Close</button>
  </div>
</div>
